import { render, staticRenderFns } from "./ali_email.vue?vue&type=template&id=a662881a&"
import script from "./ali_email.vue?vue&type=script&lang=js&"
export * from "./ali_email.vue?vue&type=script&lang=js&"
import style0 from "./ali_email.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports